import { render } from "./Navigator.vue?vue&type=template&id=df0db6be&scoped=true"
import script from "./Navigator.vue?vue&type=script&lang=js"
export * from "./Navigator.vue?vue&type=script&lang=js"

import "./Navigator.vue?vue&type=style&index=0&id=df0db6be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df0db6be"]])

export default __exports__